import React from 'react';
import {
    HighlightImage,
    TipsItemContent,
    TipsItemImage,
    TipsItemWrapper,
    TipsListContent,
    TipsListWrapper,
} from 'features/Big9Tips/styled';
import TipsListTabs from 'features/Big9Tips/TipsListTabs';
import { CAMPAIGN_IMAGE_PATH } from 'constants/appConfig';
import Text from 'ui/Text';
import { formatDate } from 'utils/UiHelper';
import { timeToUTC } from 'features/SpilKlub/state/helpers';
import Spinner from '../../ecoui/UISpinner';

const TipsList = ({
    data = [],
    onChange = () => {},
    status,
    selectArticle = () => {},
}) => {
    const sortTipsByDate = (a, b) =>
        timeToUTC(a.beginning) < timeToUTC(b.beginning) ? 1 : -1;

    return (
        <TipsListWrapper>
            <TipsListTabs onChange={onChange} />
            <TipsListContent>
                {status === 'loading' ? (
                    <Spinner className="top-indent-md bottom-indent-md " />
                ) : data.length ? (
                    data.sort(sortTipsByDate).map((item, key) => (
                        <TipsItemWrapper
                            key={key}
                            onClick={() => {
                                selectArticle(item);
                                window.scrollTo(0, 0);
                            }}
                        >
                            <TipsItemImage>
                                <HighlightImage
                                    src={CAMPAIGN_IMAGE_PATH + item.image}
                                    alt={item.title}
                                />
                            </TipsItemImage>
                            <TipsItemContent>
                                <Text
                                    color={'#9198AA'}
                                    size={'x1'}
                                    condensed
                                    margin={'0'}
                                    padding={'10px 0 5px 0'}
                                    capitalize
                                >
                                    {formatDate(item.beginning, 'dddd HH:MM')}
                                </Text>
                                <Text
                                    className={'max-two-lines hyphens'}
                                    color={'#333'}
                                    size={'x25'}
                                    condensed
                                    bold
                                    margin={'0'}
                                    padding={'0'}
                                    lh={'28'}
                                >
                                    {item.title || ''}
                                </Text>
                            </TipsItemContent>
                        </TipsItemWrapper>
                    ))
                ) : null}
            </TipsListContent>
        </TipsListWrapper>
    );
};

export default TipsList;
